import { IonButton, IonIcon, IonInput } from "@ionic/react";
import { add, remove } from "ionicons/icons";
import React from "react";

const EmptyTickComponent: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "41px",
        border: "1px solid #363E46",
        backgroundColor: "#001624",
      }}
    >
      <IonButton slot="icon-only" fill="clear" color={"dark"} disabled>
        <IonIcon slot="icon-only" icon={remove}></IonIcon>
      </IonButton>
      <IonInput
        style={{
          width: "100%",
          minHeight: 0,
          textAlign: "center",
          fontSize: "16px",
        }}
        disabled
      />
      <IonButton slot="icon-only" fill="clear" color={"dark"} disabled>
        <IonIcon slot="icon-only" icon={add}></IonIcon>
      </IonButton>
    </div>
  );
};

export default EmptyTickComponent;
